/**
 * Picks the fields TreeItem needs for inactive + invalid styling straight from the
 * API record. Validity fields are only carried when the payload provides them, so
 * legacy payloads keep the exact shape they had before (ER-9940).
 */
export const pickTreeActivationFields = (record) => {
  if (!record || typeof record !== "object") return {};
  const out = {};
  if (record.status !== undefined && record.status !== null) {
    out.status = record.status;
  }
  if (record.archived === true || record.is_archived === true) {
    out.archived = true;
  }
  if (record.is_valid !== undefined && record.is_valid !== null) {
    out.is_valid = record.is_valid;
  }
  if (record.invalidity_reason) {
    out.invalidity_reason = record.invalidity_reason;
  }
  return out;
};
